<template>
  <div class="return-depot-list">
    <div class="intro-text">
      <h1>Closest depots</h1>
      <p>
        You can hand the vehicle in at the depot where you picked it up at no
        charge.
      </p>
    </div>
    <ul>
      <li
        :id="`depot-item-${depot.id}`"
        class="depot-item"
        :class="{
          'selected-depot': selectedDepot && selectedDepot.id === depot.id
        }"
        v-for="depot in depots"
        :key="depot.id"
        @click="handleDepotClicked(depot)"
      >
        <strong>{{ depot.name }}</strong> <br />
        <span>{{ depot.address.full_address }}</span> <br />
        <span>T: {{ depot.phone }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "return-locations-depot-list",
  props: ["depots", "selectedDepot"],
  methods: {
    handleDepotClicked(depot) {
      this.$emit("depot-clicked", depot);
    }
  },
  watch: {
    selectedDepot: function(newVal) {
      const el = document.getElementById(`depot-item-${newVal.id}`);
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
};
</script>
